import React, { useState, useCallback, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useFetch from '../../hooks/useFetch';
import { logout } from "../../redux/actions/authActions";
import { GenerateDigiBCode } from '../../components/GenerateThink5whysCode';

const DigiBoutiqueHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [activeTab, setActiveTab] = useState("about");
  const [selectedBoutique, setSelectedBoutique] = useState(null);
  const [memberSearch, setMemberSearch] = useState("");
  const isLoggedIn = authState?.isLoggedIn || false;
  const userId = authState.user._id;
  const userEmail = authState.user.email;
  const userName = authState?.user?.name || "User";
  const userThink5WhysCode = authState?.user?.think5whyscode || ""; 
  const [isCreated, setIsCreated] = useState(false);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [myBoutiques, setMyBoutiques] = useState([]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };

  const [formData, setFormData] = useState({
    digibThink5WhysCode: GenerateDigiBCode(),
    digibName: "",
    digibPlace: "",
    digibOwnerThink5whysCode: userThink5WhysCode,
    digibOwnerName: userName,
    digibEmail: userEmail,
    digibMobile: "",
    digibAddress: "",
    digibState: "",
    digibPIN: "",
    digibDetails: "",
    digibMicroPage: "",
    selectedBoutiques: [], 
  });

  const boutiques = [
    { name: "Boutique Auditors", desc: "Premium auditing services for businesses and MSMEs." },
    { name: "Rural DigiBoutique", desc: "Empowering rural entrepreneurs with digital tools & support." },
    { name: "Investment DigiBoutique", desc: "Advisory for small investments & wealth creation." },
    { name: "Skill DigiBoutique", desc: "Training & skill development programs for youth." },
    { name: "Marketplace DigiBoutique", desc: "Platform to sell products, services & digital assets." },
    { name: "ESG DigiBoutique", desc: "Guidance on ESG compliance and sustainability initiatives." },
    { name: "Wellbeing DigiBoutique", desc: "Wellbeing programs for mental and physical health." },
  ];

  // const myBoutiques = [];

  const getMembersForBoutique = (boutiqueName) => {
    const dummyMembers = [
      { name: "Priya Patel", role: "Admin", joined: "2025-10-01" },
      { name: "Neha Gupta", role: "Member", joined: "2025-10-05" },
      { name: "Amit Joshi", role: "Member", joined: "2025-10-10" },
      { name: "Ritu Devi", role: "Admin", joined: "2025-09-15" },
      { name: "Sita Devi", role: "Member", joined: "2025-11-01" },
      { name: "Rajesh Verma", role: "Member", joined: "2025-10-15" },
      { name: "Lata Bai", role: "Member", joined: "2025-09-20" },
      { name: "Meera Singh", role: "Admin", joined: "2025-10-20" },
    ];
    return dummyMembers.slice(0, myBoutiques.find(b => b.name === boutiqueName)?.members || 5);
  };

  const filteredMembers = selectedBoutique
    ? getMembersForBoutique(selectedBoutique.name).filter(member =>
        member.name.toLowerCase().includes(memberSearch.toLowerCase())
      )
    : [];

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleBoutiqueSelection = (boutiqueName) => {
    setFormData((prev) => {
      const selected = prev.selectedBoutiques.includes(boutiqueName)
        ? prev.selectedBoutiques.filter((b) => b !== boutiqueName)
        : [...prev.selectedBoutiques, boutiqueName];
      return { ...prev, selectedBoutiques: selected };
    });
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  // Basic validation
  if (!formData.digibName || !formData.digibMobile){
    alert("Name & Mobile are required.");
    return;
  }

  const mobileRegex = /^\+?[0-9]{10,}$/;
  if (!mobileRegex.test(formData.digibMobile)) {
    alert("Mobile Number must contain only digits (optional leading +) and be at least 10 digits.");
    return;
  }

  if (formData.selectedBoutiques.length === 0) {
    alert("Please select at least one Boutique Type.");
    return;
  }

  // Prepare payload
  const payload = {
    digibThink5WhysCode: formData.digibThink5WhysCode,
    digibName: formData.digibName,
    digibPlace: formData.digibPlace,
    digibOwnerThink5whysCode: userThink5WhysCode,
    digibOwnerName: userName,
    digibEmail: userEmail,
    digibMobile: formData.digibMobile,
    digibAddress: formData.digibAddress,
    digibState: formData.digibState,
    digibPIN: formData.digibPIN,
    digibDetails: formData.digibDetails,
    digibMicroPage: formData.digibMicroPage,
    digibType: formData.selectedBoutiques.join(", "), // Multiple selections concatenated
    createdBy: userId,
  };

  const config = {
    url: "/digiboutique/create",
    method: "post",
    headers: { Authorization: authState.token },
    data: payload,
  };

  fetchData(config)
    .then((res) => {
      if (res?.status) {
        alert("Enrollment submitted successfully!");
        setFormData({
          digibThink5WhysCode: GenerateDigiBCode(),
          digibName: "",
          digibPlace: "",
          digibOwnerThink5whysCode: userThink5WhysCode,
          digibOwnerName: userName,
          digibEmail: userEmail,
          digibMobile: "",
          digibAddress: "",
          digibState: "",
          digibPIN: "",
          digibDetails: "",
          digibMicroPage: "",
          selectedBoutiques: [], 
        });
      } else {
        alert("Failed to submit enrollment. Try again.");
      }
    })
    .catch(() => alert("Error submitting enrollment. Please try again."));
};

const loadMyBoutiques = useCallback(() => {
  const config = {
    url: "/digiboutique/mydigib",
    method: "post",
    headers: { Authorization: authState.token },
    data: { createdBy: userId },
  };

  fetchData(config)
    .then((res) => {
      if (res?.status) {
        setMyBoutiques(res.digiBList || []);
      }
    })
    .catch(() => console.log("Error loading boutiques"));
}, [userId, authState.token]);

useEffect(() => {
  if (userId) loadMyBoutiques();
}, [userId, loadMyBoutiques]);

const formattedBoutiques = myBoutiques.map((b, index) => ({
  sn: index + 1,
  name: b.digibName,
  type: b.digibType,
  status: b.isActive ? "Active" : "Inactive",
  dateCreated: b.dateCreated
    ? new Date(b.dateCreated).toLocaleDateString()
    : "-",
}));


  const handleBoutiqueClick = (boutique) => {
    setSelectedBoutique(boutique);
  };

  const closeMembersList = () => {
    setSelectedBoutique(null);
    setMemberSearch("");
  };

  return (
    <div className="bg-black h-screen flex flex-col">
      <header className="flex flex-col px-2 py-2 bg-cyan-800 shadow-md sticky top-0 z-50">
        <div className="text-xl font-extrabold text-yellow-200 tracking-wide">
          Think5Whys DigiBoutique
        </div>
        <p className="text-xs lg:text-sm text-white text-left">
          AI-enabled digital boutiques creating job opportunities across India.
        </p>
      </header>

      {/* Tabs */}
      <nav className="flex flex-wrap justify-center gap-2 bg-black py-1 border-b border-cyan-400">
        {["about", "enrollment", "myBoutiques"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`flex-1 min-w-[100px] text-center px-4 py-2 rounded-lg text-sm sm:text-base font-semibold truncate transition 
              ${
                activeTab === tab
                  ? "bg-cyan-600 text-yellow-200 shadow-lg"
                  : "bg-cyan-800 hover:bg-cyan-700 text-white"
              }`}
          >
            {tab === "about" && "About"}
            {tab === "enrollment" && "Enrollment"}
            {tab === "myBoutiques" && "My Boutiques"}
          </button>
        ))}
      </nav>

      {/* About Section */}
      {activeTab === "about" && (
        <section className="py-2 px-4 bg-black">
          {/* <h2 className="text-lg lg:text-xl font-bold text-center mb-1 text-yellow-200">
            About Think5Whys DigiBoutique
          </h2> */}
          <p className="max-w-4xl mx-auto text-xs lg:text-sm text-center mb-1 text-white">
            An ecosystem of 7 digital boutiques enabling digital self-employment empowering individuals
          </p>
          <div className="bg-cover bg-center flex flex-col items-center justify-center text-white">
            <div className="relative z-10 w-full max-w-6xl mx-auto px-1 py-2 flex flex-col items-center">
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2 w-full">
                {boutiques.map((b, idx) => (
                  <div
                    key={idx}
                    className="bg-black border border-cyan-400 text-white p-4 rounded-xl shadow-lg"
                  >
                    <h3 className="font-semibold text-sm lg:text-m mb-2 text-white">{b.name}</h3>
                    <p className="text-xs lg:text-sm text-gray-200">{b.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex flex-row text-center gap-4 justify-center">
            <div className="bg-cyan-700 p-4 rounded-xl shadow-lg w-full">
              <h3 className="font-semibold mb-2 text-sm lg:text-lg text-yellow-200">Membership Charges</h3>
              <p className="text-gray-300 text-xs lg:text-sm">₹5,000/year per boutique</p>
            </div>
            <div className="bg-cyan-700 p-4 rounded-xl shadow-lg w-full">
              <h3 className="font-semibold mb-2 text-sm lg:text-lg text-yellow-200">Income Prospects</h3>
              <p className="text-gray-300 text-xs lg:text-sm">₹10,000 – ₹50,000/month based on engagement & referrals</p>
            </div>
            {/* <div className="bg-cyan-700 p-4 rounded-xl shadow-lg">
              <h3 className="font-semibold mb-2 text-yellow-200">Objective</h3>
              <p className="text-gray-300 text-xs lg:text-sm">
                Enable self-employment, skill-building, and community impact across India.
              </p>
            </div> */}
          </div>
        </section>
      )}

      {/* Enrollment Section */}
      {activeTab === "enrollment" && (
        <section className="py-2 px-4 bg-black">
          <h2 className="text-xl lg:text-2xl font-bold text-center mb-2 text-yellow-200">Request Enrollment</h2>
          <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-4">
            <div className="flex flex-col gap-4">
              <input
                type="text"
                name="digibThink5WhysCode"
                value={formData.digibThink5WhysCode}
                disabled={true}
                onChange={handleInputChange}
                className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />
              <input
                type="text"
                name="digibName"
                placeholder="Boutique Name"
                value={formData.digibName}
                onChange={handleInputChange}
                style={{width: "90%"}}
                className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white w-ful"
                required
              />
               <input
                type="text"
                name="digibOwnerThink5whysCode"
                value={formData.digibOwnerThink5whysCode}
                disabled={true}
                onChange={handleInputChange}
                className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />
              <input
                type="text"
                name="digibOwnerName"
                value={formData.digibOwnerName}
                disabled={true}
                onChange={handleInputChange}
                style={{width: "90%"}}
                className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />
              <input
                type="email"
                name="digibEmail"
                value={formData.digibEmail}
                disabled={true}
                onChange={handleInputChange}
                className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />
              <input
                type="tel"
                name="digibMobile"
                placeholder="Mobile Number"
                value={formData.digibMobile}
                onChange={handleInputChange}
                className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />
              <textarea
                type="text"
                name="digibAddress"
                placeholder="Address"
                value={formData.digibAddress}
                onChange={handleInputChange}
                style={{width: "100%", height: "150px"}}
                className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              /> 
              <input
                type="text"
                name="digibPlace"
                placeholder="Place"
                value={formData.digibPlace}
                onChange={handleInputChange}
                className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />            
              <input
                type="text"
                name="digibState"
                placeholder="State"
                value={formData.digibState}
                onChange={handleInputChange}
                className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />      
              <input
                type="text"
                name="digibPIN"
                placeholder="PIN Code"
                value={formData.digibPIN}
                onChange={handleInputChange}
                style={{width: "100px"}}
                className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />         
              <textarea
                type="text"
                name="digibDetails"
                placeholder="Boutique Details"
                value={formData.digibDetails}
                onChange={handleInputChange}
                style={{width: "100%", height: "200px"}}
                className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />  
              <textarea
                type="text"
                name="digibMicroPage"
                placeholder="Boutique Webpage"
                value={formData.digibMicroPage}
                onChange={handleInputChange}
                style={{width: "100%", height: "400px"}}
                className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                required
              />   
            </div>                
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
              {boutiques.map((b, idx) => (
                <label key={idx} className="flex items-center gap-2 bg-white/10 p-2 rounded-lg cursor-pointer hover:bg-white/20 transition">
                  <input
                    type="checkbox"
                    checked={formData.selectedBoutiques.includes(b.name)}
                    onChange={() => handleBoutiqueSelection(b.name)}
                  />
                  <span className="text-white text-sm">{b.name}</span>
                </label>
              ))}
            </div>
            <button type="submit" className="w-full py-2 bg-blue-600 hover:bg-blue-700 rounded-lg font-semibold text-white">
              Submit Enrollment
            </button>
          </form>
        </section>
      )}

      {/* My Boutiques Section */}
      {activeTab === "myBoutiques" && (
        <section className="min-h-screen py-2 px-4 bg-black">
          <h2 className="text-xl lg:text-2xl font-bold text-center mb-2 text-yellow-200">
            My Boutiques
          </h2>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px] bg-gray-800 border border-cyan-500 rounded-lg">
              <thead className="bg-cyan-900">
                <tr>
                  {["SN", "Boutique Name", "Type", "Status", "Date Created"].map(
                    (heading) => (
                      <th
                        key={heading}
                        className="p-3 text-left text-cyan-200 text-sm"
                      >
                        {heading}
                      </th>
                    )
                  )}
                </tr>
              </thead>

              <tbody>
                {formattedBoutiques.length > 0 ? (
                  formattedBoutiques.map((row) => (
                    <tr key={row.sn} className="hover:bg-gray-700 transition">
                      <td className="p-3 border-t border-cyan-500 text-white">{row.sn}</td>
                      <td className="p-3 border-t border-cyan-500 text-white">{row.name}</td>
                      <td className="p-3 border-t border-cyan-500 text-white">{row.type}</td>

                      <td className="p-3 border-t border-cyan-500">
                        <span
                          className={`px-2 py-1 rounded text-xs ${
                            row.status === "Active"
                              ? "bg-green-600"
                              : "bg-yellow-600"
                          }`}
                        >
                          {row.status}
                        </span>
                      </td>

                      <td className="p-3 border-t border-cyan-500 text-white">
                        {row.dateCreated}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="p-4 text-center text-gray-300 border-t border-cyan-500"
                    >
                      No boutiques found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      )}


      {/* Members List Modal */}
      {selectedBoutique && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-gray-800 p-6 rounded-lg max-w-md w-full mx-4 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-yellow-200">
                {selectedBoutique.name} Members ({filteredMembers.length})
              </h3>
              <button onClick={closeMembersList} className="text-white hover:text-cyan-200 text-2xl">&times;</button>
            </div>
            <input
              type="text"
              placeholder="Search members..."
              value={memberSearch}
              onChange={(e) => setMemberSearch(e.target.value)}
              className="w-full bg-gray-900 border border-cyan-500 rounded p-2 text-white mb-4"
            />
            <ul className="space-y-2 text-sm">
              {filteredMembers.map((member, idx) => (
                <li key={idx} className="p-2 bg-gray-700 rounded flex justify-between">
                  <span className="text-white">{member.name}</span>
                  <span className="text-gray-400">{member.role} | {member.joined}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-cyan-800 text-white py-2 px-2 sm:px-2 md:px-4">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-xs lg:text-sm text-yellow-200">&copy; 2025 Think5Whys Global DeepTech Solutions</p>
          <div className="flex space-x-6 mt-1 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-cyan-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-cyan-400 transition">Privacy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-cyan-400 transition">Terms</Link>
            <Link to="/contact-us" className="text-white hover:text-cyan-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DigiBoutiqueHome;
